import React from 'react';
import { useTranslation } from 'react-i18next';
import type { FeedbackSortField } from '../types';

interface FeedbackToolbarProps {
  sort: FeedbackSortField;
  pageSize: number;
  onSortChange: (sort: FeedbackSortField) => void;
  onPageSizeChange: (size: number) => void;
}

const FeedbackToolbar: React.FC<FeedbackToolbarProps> = ({
  sort,
  pageSize,
  onSortChange,
  onPageSizeChange,
}) => {
  const { t } = useTranslation();
  const controlClass = 'h-11 w-full rounded-xl border border-outline-variant bg-white px-3 text-body-md text-on-surface focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary/15';

  return (
    <div className="flex flex-col gap-3 border-b border-outline-variant bg-white px-4 py-4 sm:flex-row sm:items-end sm:justify-end sm:px-5">
      <div className="grid w-full grid-cols-1 gap-2 sm:w-auto sm:grid-cols-[minmax(190px,240px)_140px]">
        <label className="flex min-w-0 flex-col gap-1.5 font-label-sm text-secondary">
          {t('admin.feedbacks.toolbar.sort')}
          <select
            className={controlClass}
            value={sort}
            onChange={(event) => onSortChange(event.target.value as FeedbackSortField)}
          >
            <option value="id">{t('admin.feedbacks.sort.id')}</option>
            <option value="username">{t('admin.feedbacks.sort.username')}</option>
            <option value="rating">{t('admin.feedbacks.sort.rating')}</option>
            <option value="createAt">{t('admin.feedbacks.sort.create_at')}</option>
            <option value="updateAt">{t('admin.feedbacks.sort.update_at')}</option>
          </select>
        </label>
        <label className="flex min-w-0 flex-col gap-1.5 font-label-sm text-secondary">
          {t('admin.feedbacks.toolbar.page_size')}
          <select
            className={controlClass}
            value={pageSize}
            onChange={(event) => onPageSizeChange(Number(event.target.value))}
          >
            {[10, 20, 50].map((size) => (
              <option key={size} value={size}>{t('admin.feedbacks.toolbar.per_page', { size })}</option>
            ))}
          </select>
        </label>
      </div>
    </div>
  );
};

export default FeedbackToolbar;
